var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"p-5 border-b-4 border-tertiary flex-grow text-sm",class:_vm.labelClass},[_c('span',{domProps:{"innerHTML":_vm._s(_vm.label)}}),_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }